export default {
	title: 'Navigation Menu',
};
